import { API as e, Resource as t } from "@coveo/platform-client";
// src/resources/AgentGatewayConfiguration.ts
var n = class extends t {
	async put(t, n) {
		let r = `/gatewayagentdiscovery/restricted/organizations/${e.orgPlaceholder}/commerce/tracking-ids/${t}/configuration`;
		await this.api.put(r, n);
	}
};
export { n as AgentGatewayConfiguration };

//# sourceMappingURL=AgentGatewayConfiguration.js.map